// extracted by mini-css-extract-plugin
export default {"form":"Form-module__[local]___rKBgx"};